import state from './acmappliance.state'
import mutations from './acmappliance.mutations'
import actions from './acmappliance.actions'

export default {
  state,
  mutations,
  actions
}
